var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "21px",
    height: "21px",
    viewBox: "0 0 64.000000 64.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,64.000000) scale(0.100000,-0.100000)",
    fill: "#9e9e9e",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87 594 c-4 -4 -7 -112 -7 -240 l0 -233 -27 -3 c-31 -3 -43 -38 -23 -64 18 -20 522 -21 539 0 8 9 11 91 9 277 l-3 264 -241 3 c-132 1 -243 -1 -247 -4z m471 -271 c-3 -218 -5 -258 -18 -258 -8 0 -17 11 -20 25 l-6 25 -207 3 -207 2 0 230 0 230 230 0 230 0 -2 -257z m-58 -243 c0 -20 -5 -20 -227 -18 -208 3 -228 5 -231 21 -3 16 13 17 227 17 225 0 231 -1 231 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177 500 c-12 -12 -17 -29 -15 -52 2 -28 7 -34 31 -36 21 -3 27 -9 27 -28 0 -17 -5 -24 -20 -24 -11 0 -20 7 -20 15 0 8 -4 15 -10 15 -18 0 -11 -35 10 -53 20 -16 22 -16 41 2 15 13 19 29 17 52 -2 29 -7 35 -30 37 -22 3 -28 9 -28 28 0 17 5 24 20 24 11 0 20 -7 20 -15 0 -8 5 -15 10 -15 17 0 11 35 -10 53 -24 20 -21 20 -43 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280 490 c0 -5 23 -10 50 -10 28 0 50 5 50 10 0 6 -22 10 -50 10 -27 0 -50 -4 -50 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400 490 c0 -5 18 -10 40 -10 22 0 40 5 40 10 0 6 -18 10 -40 10 -22 0 -40 -4 -40 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280 450 c0 -6 33 -10 80 -10 47 0 80 4 80 10 0 6 -33 10 -80 10 -47 0 -80 -4 -80 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280 350 c0 -6 40 -10 100 -10 60 0 100 4 100 10 0 6 -40 10 -100 10 -60 0 -100 -4 -100 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280 310 c0 -5 23 -10 50 -10 28 0 50 5 50 10 0 6 -22 10 -50 10 -27 0 -50 -4 -50 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400 310 c0 -5 9 -10 20 -10 11 0 20 5 20 10 0 6 -9 10 -20 10 -11 0 -20 -4 -20 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130 180 c0 -11 5 -20 10 -20 6 0 10 9 10 20 0 11 -4 20 -10 20 -5 0 -10 -9 -10 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180 180 c0 -11 5 -20 10 -20 6 0 10 9 10 20 0 11 -4 20 -10 20 -5 0 -10 -9 -10 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230 180 c0 -11 5 -20 10 -20 6 0 10 9 10 20 0 11 -4 20 -10 20 -5 0 -10 -9 -10 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280 180 c0 -11 5 -20 10 -20 6 0 10 9 10 20 0 11 -4 20 -10 20 -5 0 -10 -9 -10 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330 180 c0 -11 5 -20 10 -20 6 0 10 9 10 20 0 11 -4 20 -10 20 -5 0 -10 -9 -10 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380 180 c0 -11 5 -20 10 -20 6 0 10 9 10 20 0 11 -4 20 -10 20 -5 0 -10 -9 -10 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430 180 c0 -11 5 -20 10 -20 6 0 10 9 10 20 0 11 -4 20 -10 20 -5 0 -10 -9 -10 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480 180 c0 -11 5 -20 10 -20 6 0 10 9 10 20 0 11 -4 20 -10 20 -5 0 -10 -9 -10 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530 180 c0 -11 5 -20 10 -20 6 0 10 9 10 20 0 11 -4 20 -10 20 -5 0 -10 -9 -10 -20z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrder);
export default __webpack_public_path__ + "static/media/order.10fcb0681252afd27f4fbcec59d904a1.svg";
export { ForwardRef as ReactComponent };